// extracted by mini-css-extract-plugin
module.exports = {"toggle":"CollapseToggle_toggle__2IopJ"};